import React, { useMemo } from 'react'
import { AngelPlayer, createAsset } from '@/organisms/AngelPlayer'
import { incrementUserViewCount } from '@/organisms/GetAppBanner/GetAppBannerUtil'
import { useLivestream } from '@/organisms/Livestream/LivestreamProvider'
import { useSafeAnalytics } from '@/utils/analytics'

interface LivestreamPlayerProps {
  guid: string
  name: string
  description: string
  url?: string
}

export const LivestreamPlayer: React.FC<LivestreamPlayerProps> = ({ guid, name, description, url }) => {
  const { livestream } = useLivestream()
  const { track } = useSafeAnalytics()

  const asset = useMemo(
    () =>
      createAsset({
        guid: guid,
        url: livestream?.url ?? (url as string),
        projectSlug: livestream?.projectSlug,
        videoType: 'livestream',
        name: name,
        slug: name,
        subtitle: description,
        title: name,
      }),
    [description, guid, livestream?.projectSlug, name, url, livestream?.url],
  )

  return (
    <AngelPlayer
      autoplay
      asset={asset}
      playerContainerClassName="lg:h-[60vh]"
      onStart={() => {
        incrementUserViewCount()
        track('Livestream Playback Started', {
          asset_id: asset?.analytics.content_id,
          description: asset?.analytics.description,
          episode: asset?.analytics.episodeNumber?.toString(),
          position: Math.floor(asset?.analytics?.position ?? 0),
          program: asset?.projectSlug,
          publisher: asset?.publisherName,
          season: asset?.analytics.seasonId,
          title: asset?.analytics.title,
          total_length: asset?.analytics.total_length,
          video_type: asset?.analytics.videoType,
        })
      }}
    />
  )
}
